// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1TgC2","cell":"ColumnAccessor_cell__gSzPT","firstCellAccent":"ColumnAccessor_firstCellAccent__3fTGH"};